module.exports = __webpack_public_path__ + "img/logo_cosmos.a5d1b586.png";